import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "ab-comment-activity",
  templateUrl: "./comment-activity.component.html",
})
export class CommentActivityComponent implements OnInit {
  @Input() public activity: any;
  public comment: string;
  public groupId: string;

  public ngOnInit() {
    const parameters = this.activity.parameters || {};
    this.comment = parameters[":comment"];
    this.groupId = parameters[":commentable_id"];
  }
}
